<template>
<div style="padding-top:-2px;margin-top:-2px;">
    <template v-if="!check">
        <v-label>
            <b>{{ label }}</b>
        </v-label>
        <vc-select-generic ref='sgeneric' style="margin-top:-19px;" :config="config" :disabled="disabled" :readonly="readonly" :itemvalue="itemvalue" :add="add" :clearable="clearable" :itemtext="abbr ? 'DedAbbreviation' : 'DedDescription'" @add="addEvent()" :noDefault="clearable" :value="valueLocal" @input="input($event)" @change="change($event)" :returnObject="returnObject" :autofocus="autofocus" @updateData='$emit("updateData",$event)' :outlined="outlined" :autocomplete="autocomplete" :full="full" />
    </template>

    <div v-if="check">
        <v-checkbox class="mt-0" hide-details="" v-for="(item, i) in items" :value="item[itemvalue]" :disabled="disabled" :readonly="readonly" v-model="selected" :label="abbr ? item.DedAbbreviation : item.DedDescription" :key="i" />
    </div>

    <v-dialog light style="border-radius:0px !important;" v-model="dialogAdd" v-if="dialogAdd" width="600">
        <v-card>
           <!--  <v-toolbar height="25px" dark flat dense elevation="0" color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon @click="dialogAdd = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar> -->
            <vc-header title="" close @close="dialogAdd=false"></vc-header>

            <v-divider></v-divider>
            <v-col style="padding-top:0px;">
                <definition-detail @refresh="refresh($event)" :defID="def"></definition-detail>
            </v-col>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import _sDefinition from "@/services/General/GenDefinitionService.js";

import DefinitionDetail from "@/views/General/GenDefinitionDetail";


export default {
    components: {DefinitionDetail},
    props: 
        {
        itemvalue: {
            type: String,
            default: "DedValue",
        },
        abbr: {
            type: Boolean,
            default: false,
        },
        value: null,
        label: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        def: {
            type: Number,
            default: 0,
        },
        add: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        dgr: {
            type: Number,
            default: 0,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },

        outlined: {
            type: Boolean,
            default: true
        },
        check: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        selected: [],
        valueRadio: null,
        valueLocal: null,
        dialogAdd: false,
        item: 0,
        items: [],
        config: {
            url: _sDefinition.definitiongroupURL(),
            title: "",
            params: {
                defID: 0,
                dgrID: 0,
                requestID: 0,
            },
        },
    }),

    watch: {
        error(msg) {
            this.$fun.alert(msg, "warning");
            this.focus();
            this.setColor("error");
        },

        dgr() {
            this.config.params.dgrID = this.dgr;
        },
        def() {
            this.config.params.defID = this.def;
        },
        selected(value) {
            let f = this.items.find((x) => x[this.itemvalue] == value);
            //console.log("definition",f);
            if (!this.returnObject) this.$emit("input", value);
            else this.$emit("input", f);
        },
        /* valueRadio(value) {
            this.$emit("input", value);
            this.$emit(
                "returnObject",
                this.items.find((x) => x[this.id] == value)
            );
        }, */

        value(value) {
            if (this.radio) this.valueRadio = value;
            else if (this.check) this.selected = value;
            else this.valueLocal = this.value;
        },
    },
    methods: {
        isFocused(val) {
            this.$refs.sgeneric.isFocused(val);
        },
        focus() {
            this.$refs.sgeneric.focus();
        },

        refresh(item) {
            this.$refs.sgeneric.load();
        },
        addEvent() {
            this.dialogAdd = true;
        },
        input(item) {
            this.$emit("input", item);
        },
        change(item) {
            this.$emit("change", item);
        },
    },
    created() {

        this.config.title = this.label;
        this.config.params.defID = this.def;
        this.config.params.dgrID = this.dgr;
        this.config.params.requestID = this.$fun.getUserID();
        this.valueLocal = this.value;
        // console.log("AQUIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII---> ");
        if (this.check) {
            // console.log("Se ejecuta priemro---> ");
            this.$http
                .post(
                    _sDefinition.definitiongroupURL(), {}, {
                        params: this.config.params,
                    }
                )
                .then((r) => {
                    if (r.status == 200) {
                        this.items = r.data.Result;
                        this.$emit("getData", this.items);
                    }
                });
                // console.log("Se ejecuta priemro11111---> ");
        }

    },
};
</script>
